import React, { useState } from 'react'
import { Link, Switch, Route } from 'react-router-dom'
import { Menu, Dropdown } from 'antd'

import { AiOutlineDown, AiOutlineReload } from 'react-icons/ai'

import { stringifyDate, useListData } from '../../modules'

import Receive from '../../components/reusable/receive'

import Document from '../../components/drawers/document'

const Documents = () => {
    const [string, setString] = useState('')

    const [
        { loading, error, fetch },
        { list: documents },
        { navigate, Paginate, page = 1, limit = 10 }
    ] = useListData('myAllowedHostedDocuments', { string }, { notify: true }, "documents")

    const refresh = () => {
        navigate(1)
        fetch()
    }

    const search = str => {
        setString(str)
        refresh()
    }

    return (
        <div className="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto">
            <div className="sm:flex sm:justify-between sm:items-center mb-8">
                <input
                    onChange={e => search(e.target.value)}
                    className="appearance-none block max-w-4xl bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white"
                    id="grid-search"
                    type="text"
                    placeholder="Search for Document" />
            </div>
            <div className="col-span-full xl:col-span-8 bg-white shadow-lg rounded-sm border border-gray-200">
                <header className="px-5 py-4 border-b border-gray-100 flex justify-between items-center">
                    <h2 className="font-semibold text-gray-800">Hosted Documents</h2>
                    <span className="flex items-center justify-between">
                        <button onClick={refresh} className="btn ml-2 py-3 hisani-btn-green-light text-white">
                            <AiOutlineReload style={{ color: "white" }} />
                        </button>
                    </span>
                </header>
                <div className="p-3">
                    <Receive
                        progress
                        loading={loading}
                        error={error}>
                        {
                            documents?.length > 0 ?
                                <div className="overflow-x-auto">
                                    <table className="table-auto w-full">
                                        {/* Table header */}
                                        <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
                                            <tr>
                                                <th className="p-2">
                                                    <div className="font-semibold text-center">No.</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-left">Document Name</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-left">Current Version</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-left">Updated On</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-center"></div>
                                                </th>
                                            </tr>
                                        </thead>
                                        {/* Table body */}
                                        <tbody className="text-sm font-medium divide-y divide-gray-100">
                                            {
                                                documents.map((doc, key) =>
                                                    <tr>
                                                        <td className="p-2">
                                                            <div className="text-center">
                                                                { ((page - 1) * limit) + (key + 1) }.
                                                            </div>
                                                        </td>
                                                        <td className="p-2">
                                                            { doc.name }
                                                        </td>
                                                        <td className="p-2">
                                                            Version { doc.previous.length + 1 }
                                                        </td>
                                                        <td className="p-2">
                                                            <div className="text-left">{stringifyDate(doc.date)}</div>
                                                        </td>
                                                        <td className="p-2 text-center">
                                                            <Dropdown
                                                                overlay={
                                                                    <Menu>
                                                                        <Link to={ `/app/documents/docs/${doc._id}` }><Menu.Item>View Document</Menu.Item></Link>
                                                                    </Menu>
                                                                }>
                                                                <a className="ant-dropdown-link flex items-center h-10" onClick={e => e.preventDefault()}><span className="mr-2">Actions</span> <AiOutlineDown /></a>
                                                            </Dropdown>
                                                        </td>
                                                    </tr>
                                                )
                                            }
                                        </tbody>
                                    </table>
                                </div>
                                :
                                <div className="w-full h-16 flex items-center justify-center">
                                    <p className="font-semibold text-base">No documents have been made available</p>
                                </div>
                        }
                    </Receive>
                    {Paginate}
                </div>
                <Switch>
                    <Route path="/app/documents/docs/:id">
                        <Document />
                    </Route>
                </Switch>
            </div>
        </div>       
    )
}

export default Documents